/**
 * Contact Form Data Constants
 * Category definitions and field configurations for the contact form
 */

// ============================================
// CONTACT CATEGORIES
// ============================================

export const CONTACT_CATEGORIES = [
  {
    id: 'api-data-access',
    label: 'Systematic Data Access',
    description: 'Dataset delivery through S3 or a Snowflake pipeline',
  },
  {
    id: 'enterprise-sales',
    label: 'Enterprise / Sales',
    description: 'Team licenses, custom pricing',
  },
  {
    id: 'product-feedback',
    label: 'Product Feedback',
    description: 'Feature requests, suggestions',
  },
  {
    id: 'support',
    label: 'Support',
    description: 'Technical issues, account problems',
  },
  {
    id: 'other',
    label: 'Other',
    description: 'General inquiries',
  },
];

// ============================================
// CATEGORY-SPECIFIC FIELD OPTIONS
// ============================================

export const USE_CASE_OPTIONS = [
  'Investment Research',
  'Portfolio Monitoring',
  'Market Analysis',
  'Competitive Intelligence',
  'Product Development',
  'Other',
];


export const TEAM_SIZE_OPTIONS = [
  '1-5 users',
  '6-15 users',
  '16-50 users',
  '50+ users',
];

export const FEEDBACK_TYPE_OPTIONS = [
  'Feature Request',
  'Improvement Suggestion',
  'Data Coverage Request',
  'User Experience',
  'Other',
];

export const ISSUE_TYPE_OPTIONS = [
  'Account Access',
  'Billing / Subscription',
  'Data Issue',
  'Technical Problem',
  'Other',
];

// ============================================
// FIELD CONFIGURATION BY CATEGORY
// ============================================

export const CATEGORY_FIELDS = {
  'api-data-access': [
    {
      name: 'useCase',
      label: 'Use Case',
      type: 'select',
      options: USE_CASE_OPTIONS,
      required: false,
    },
  ],
  'enterprise-sales': [
    {
      name: 'teamSize',
      label: 'Team Size',
      type: 'select',
      options: TEAM_SIZE_OPTIONS,
      required: false,
    },
  ],
  'product-feedback': [
    {
      name: 'feedbackType',
      label: 'Feedback Type',
      type: 'select',
      options: FEEDBACK_TYPE_OPTIONS,
      required: false,
    },
  ],
  'support': [
    {
      name: 'issueType',
      label: 'Issue Type',
      type: 'select',
      options: ISSUE_TYPE_OPTIONS,
      required: false,
    },
  ],
  'other': [
    {
      name: 'subject',
      label: 'Subject',
      type: 'text',
      required: false,
    },
  ],
};

// ============================================
// COMMON FIELDS (always shown)
// ============================================

export const COMMON_FIELDS = [
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
  },
  {
    name: 'email',
    label: 'Email',
    type: 'email',
    required: true,
  },
  {
    name: 'company',
    label: 'Company',
    type: 'text',
    required: false,
  },
  {
    name: 'phone',
    label: 'Phone',
    type: 'tel',
    required: false,
  },
];

// ============================================
// VALIDATION
// ============================================

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (email) => {
  return EMAIL_REGEX.test(email);
};

export const validateRequired = (value) => {
  return typeof value === 'string' && value.trim().length > 0;
};
